import type { BannerView, ServiceStatus } from "@/client-types/service-status";

/**
 * Shown when the backend cannot be reached and nobody has written a message yet — the gap between
 * an outage starting and the admin noticing it.
 */
const GENERIC_OUTAGE: BannerView = {
  severity: "outage",
  title: "Vi har tekniske problemer lige nu",
  message: "Siden kan ikke hente data i øjeblikket. Vi arbejder på at få den op at køre igen.",
  dismissible: false,
};

/**
 * An active message always wins over the generic one, so the admin can replace "something is wrong"
 * with a real explanation and a time estimate. An outage banner cannot be dismissed: when nothing
 * works, the explanation has to stay on screen.
 */
export function resolveBanner(status: ServiceStatus | null, backendUp: boolean): BannerView | null {
  if (status?.active) {
    return {
      severity: status.severity,
      title: status.title,
      message: status.message,
      ...(status.updatedAt ? { updatedAt: status.updatedAt } : {}),
      dismissible: status.severity !== "outage",
    };
  }

  return backendUp ? null : GENERIC_OUTAGE;
}
